var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrapper"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_c('q-spinner',{attrs:{"color":"primary","size":"2.5em"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }